/*
 * Young Farts site-wide Back/Forward restoration.
 * Keeps each browser-history entry's exact document scroll, important inner
 * scroll areas, and a stable visual anchor. Collection/search grids still use
 * their dedicated loader to rebuild infinite-scroll pages before this script
 * reveals the page.
 */
(function () {
  'use strict';

  if (window.__yfSiteReturnStateInstalled) return;
  window.__yfSiteReturnStateInstalled = true;

  var STATE_NAME = 'yfSiteReturn';
  var STORAGE_PREFIX = 'yfSiteReturn:';
  var STORAGE_INDEX = 'yfSiteReturn:index';
  var MAX_AGE = 4 * 60 * 60 * 1000;
  var MAX_STORED_ROUTES = 30;
  var RESTORING_CLASS = 'yf-site-return-restoring';
  var COLLECTION_RESTORING_CLASS = 'yf-collection-return-restoring';
  var SCROLL_SAVE_DELAY = 140;

  var originalPushState = history.pushState.bind(history);
  var originalReplaceState = history.replaceState.bind(history);
  var saveTimer = null;
  var restoreRunning = false;
  var navigationPending = false;
  var lastDetailedCapture = 0;

  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  function now() {
    return Date.now ? Date.now() : new Date().getTime();
  }

  function randomId() {
    return 'yf-' + now().toString(36) + '-' + Math.random().toString(36).slice(2, 9);
  }

  function routeKey(input) {
    try {
      var url = input ? new URL(input, window.location.href) : new URL(window.location.href);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return window.location.pathname + window.location.search + window.location.hash;
    }
  }

  function safeParse(value) {
    try {
      return JSON.parse(value || 'null');
    } catch (error) {
      return null;
    }
  }

  function storageKey(key) {
    return STORAGE_PREFIX + key;
  }

  function rememberStorageKey(key) {
    try {
      var index = safeParse(sessionStorage.getItem(STORAGE_INDEX)) || [];
      index = index.filter(function (item) { return item !== key; });
      index.unshift(key);
      index.slice(MAX_STORED_ROUTES).forEach(function (oldKey) {
        sessionStorage.removeItem(storageKey(oldKey));
      });
      sessionStorage.setItem(STORAGE_INDEX, JSON.stringify(index.slice(0, MAX_STORED_ROUTES)));
    } catch (error) {
      // Session storage can be unavailable in private browsing.
    }
  }

  function storeFallback(state) {
    if (!state || !state.key) return;
    try {
      sessionStorage.setItem(storageKey(state.key), JSON.stringify(state));
      rememberStorageKey(state.key);
    } catch (error) {
      // history.state remains the primary source.
    }
  }

  function readFallback(key) {
    try {
      return safeParse(sessionStorage.getItem(storageKey(key)));
    } catch (error) {
      return null;
    }
  }

  function isFresh(state) {
    return Boolean(state && now() - Number(state.timestamp || 0) < MAX_AGE);
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/[^a-zA-Z0-9_-]/g, function (character) {
      return '\\' + character.charCodeAt(0).toString(16) + ' ';
    });
  }

  function elementSelector(element) {
    if (!element || element.nodeType !== 1) return '';

    if (element.id) return '#' + cssEscape(element.id);

    var productUrl = element.getAttribute && element.getAttribute('data-yf-product-url');
    if (productUrl) {
      try {
        return '[data-yf-product-url="' + cssEscape(new URL(productUrl, window.location.origin).pathname) + '"]';
      } catch (error) {
        // Fall through to a structural selector.
      }
    }

    var parts = [];
    var current = element;
    var depth = 0;

    while (current && current !== document.body && depth < 6) {
      if (current.id) {
        parts.unshift('#' + cssEscape(current.id));
        break;
      }

      var tag = current.tagName.toLowerCase();
      var parent = current.parentElement;
      if (!parent) break;

      var sameTag = Array.prototype.filter.call(parent.children, function (child) {
        return child.tagName === current.tagName;
      });

      if (sameTag.length > 1) {
        tag += ':nth-of-type(' + (sameTag.indexOf(current) + 1) + ')';
      }

      parts.unshift(tag);

      if (parent.classList && parent.classList.contains('shopify-section') && parent.id) {
        parts.unshift('#' + cssEscape(parent.id));
        break;
      }

      current = parent;
      depth += 1;
    }

    return parts.join(' > ');
  }

  function findProductCard(path) {
    if (!path) return null;
    var cards = document.querySelectorAll('[data-yf-collection-product-card][data-yf-product-url]');

    for (var index = 0; index < cards.length; index += 1) {
      try {
        if (new URL(cards[index].getAttribute('data-yf-product-url'), window.location.origin).pathname === path) {
          return cards[index];
        }
      } catch (error) {
        // Ignore malformed card URLs.
      }
    }

    return null;
  }

  function captureAnchor() {
    var candidates = document.querySelectorAll(
      '[data-yf-collection-product-card], [data-yf-return-anchor], main .shopify-section[id], main section[id], main article[id], main [id]'
    );
    var viewportTarget = Math.min(120, Math.max(20, window.innerHeight * 0.18));
    var best = null;
    var bestDistance = Infinity;

    for (var index = 0; index < candidates.length; index += 1) {
      var element = candidates[index];
      var rect = element.getBoundingClientRect();
      if (rect.height <= 0 || rect.width <= 0 || rect.bottom <= 0 || rect.top >= window.innerHeight) continue;

      var distance = Math.abs(rect.top - viewportTarget);
      if (rect.top <= viewportTarget && rect.bottom >= viewportTarget) distance *= 0.2;

      if (distance < bestDistance) {
        best = element;
        bestDistance = distance;
      }
    }

    if (!best) return null;

    var cardUrl = best.getAttribute && best.getAttribute('data-yf-product-url');
    var productPath = '';
    if (cardUrl) {
      try { productPath = new URL(cardUrl, window.location.origin).pathname; } catch (error) {}
    }

    return {
      selector: productPath ? '' : elementSelector(best),
      productPath: productPath,
      viewportTop: best.getBoundingClientRect().top
    };
  }

  function findAnchor(anchor) {
    if (!anchor) return null;
    if (anchor.productPath) {
      var card = findProductCard(anchor.productPath);
      if (card) return card;
    }
    if (!anchor.selector) return null;
    try {
      return document.querySelector(anchor.selector);
    } catch (error) {
      return null;
    }
  }

  function captureInnerScroll() {
    // Capture every independently scrolled area (filter sidebars, drawers,
    // sliders, product galleries, comparison tables, diagrams, etc.). This is
    // only run immediately before navigation/pagehide, not on every scroll.
    var elements = document.body ? document.body.getElementsByTagName('*') : [];
    var saved = [];

    for (var index = 0; index < elements.length && saved.length < 32; index += 1) {
      var element = elements[index];
      var top = Number(element.scrollTop || 0);
      var left = Number(element.scrollLeft || 0);
      if (!top && !left) continue;
      if (element === document.documentElement || element === document.body) continue;

      var stableSelector = elementSelector(element);
      if (!stableSelector) continue;

      saved.push({
        selector: stableSelector,
        top: top,
        left: left
      });
    }

    return saved;
  }

  function captureDetailsState() {
    var details = document.querySelectorAll('details[id], .shopify-section[id] details');
    var saved = [];

    for (var index = 0; index < details.length && saved.length < 30; index += 1) {
      var selector = elementSelector(details[index]);
      if (!selector) continue;
      saved.push({ selector: selector, open: Boolean(details[index].open) });
    }

    return saved;
  }

  function collectionSnapshot() {
    var pagination = document.querySelector('collection-dynamic-pagination');
    if (!pagination) return null;

    return {
      loadedPage: Number(pagination.currentPage || pagination.getAttribute('current-page') || 1),
      totalPages: Number(pagination.totalPages || pagination.getAttribute('total-pages') || 1)
    };
  }

  function currentHistoryObject() {
    return history.state && typeof history.state === 'object' ? history.state : {};
  }

  function buildState(detailed) {
    var historyObject = currentHistoryObject();
    var previous = historyObject[STATE_NAME] && typeof historyObject[STATE_NAME] === 'object'
      ? historyObject[STATE_NAME]
      : {};
    var shouldCaptureDetails = detailed || now() - lastDetailedCapture > 1200;

    if (shouldCaptureDetails) lastDetailedCapture = now();

    return {
      entryId: previous.entryId || randomId(),
      key: routeKey(),
      scrollX: window.pageXOffset || document.documentElement.scrollLeft || 0,
      scrollY: window.pageYOffset || document.documentElement.scrollTop || 0,
      viewportWidth: window.innerWidth || 0,
      viewportHeight: window.innerHeight || 0,
      documentHeight: Math.max(document.body ? document.body.scrollHeight : 0, document.documentElement.scrollHeight || 0),
      anchor: shouldCaptureDetails ? captureAnchor() : (previous.anchor || null),
      innerScroll: detailed ? captureInnerScroll() : (previous.innerScroll || []),
      details: detailed ? captureDetailsState() : (previous.details || []),
      collection: collectionSnapshot() || previous.collection || null,
      timestamp: now()
    };
  }

  function commitState(detailed) {
    if (restoreRunning) return null;
    var state = buildState(Boolean(detailed));
    var current = currentHistoryObject();
    originalReplaceState(Object.assign({}, current, (function () {
      var next = {};
      next[STATE_NAME] = state;
      return next;
    })()), '', window.location.href);
    storeFallback(state);
    return state;
  }

  function readState() {
    var current = currentHistoryObject();
    var state = current[STATE_NAME];
    if (state && state.key === routeKey() && isFresh(state)) return state;

    state = readFallback(routeKey());
    if (state && state.key === routeKey() && isFresh(state)) return state;
    return null;
  }

  function matchingCollectionReturnExists() {
    var state = currentHistoryObject().yfCollectionReturn;
    if (!state) {
      try { state = safeParse(sessionStorage.getItem('yfCollectionReturn')); } catch (error) {}
    }
    if (!state || !isFresh(state)) return false;

    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      var params = Array.from(url.searchParams.entries()).sort(function (a, b) {
        if (a[0] === b[0]) return String(a[1]).localeCompare(String(b[1]));
        return String(a[0]).localeCompare(String(b[0]));
      });
      var sorted = new URLSearchParams();
      params.forEach(function (pair) { sorted.append(pair[0], pair[1]); });
      var key = url.pathname + (sorted.toString() ? '?' + sorted.toString() : '');
      return state.collectionKey === key || state.urlKey === routeKey();
    } catch (error) {
      return false;
    }
  }

  function hideForRestore() {
    document.documentElement.classList.add(RESTORING_CLASS);
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  }

  function revealAfterRestore() {
    document.documentElement.classList.remove(RESTORING_CLASS);
    window.__yfSiteReturnRestorePending = false;
    restoreRunning = false;
    commitState(true);
  }

  function restoreDetails(state) {
    if (!state || !Array.isArray(state.details)) return;
    state.details.forEach(function (item) {
      if (!item || !item.selector) return;
      try {
        var element = document.querySelector(item.selector);
        if (element && element.tagName === 'DETAILS') element.open = Boolean(item.open);
      } catch (error) {}
    });
  }

  function restoreInnerScroll(state) {
    if (!state || !Array.isArray(state.innerScroll)) return;
    state.innerScroll.forEach(function (item) {
      if (!item || !item.selector) return;
      try {
        var element = document.querySelector(item.selector);
        if (!element) return;
        element.scrollTop = Number(item.top || 0);
        element.scrollLeft = Number(item.left || 0);
      } catch (error) {}
    });
  }

  function targetScroll(state) {
    var x = Number(state.scrollX || 0);
    var y = Number(state.scrollY || 0);
    var anchor = findAnchor(state.anchor);

    if (anchor && state.anchor && Number.isFinite(Number(state.anchor.viewportTop))) {
      y = window.pageYOffset + anchor.getBoundingClientRect().top - Number(state.anchor.viewportTop);
    }

    var maxY = Math.max(0, (document.documentElement.scrollHeight || 0) - (window.innerHeight || 0));
    return {
      x: Math.max(0, Number.isFinite(x) ? x : 0),
      y: Math.max(0, Math.min(Number.isFinite(y) ? y : 0, maxY))
    };
  }

  function instantScroll(position) {
    var root = document.documentElement;
    var previousRootBehavior = root.style.scrollBehavior;
    var previousBodyBehavior = document.body ? document.body.style.scrollBehavior : '';
    root.style.setProperty('scroll-behavior', 'auto', 'important');
    if (document.body) document.body.style.setProperty('scroll-behavior', 'auto', 'important');
    window.scrollTo(position.x, position.y);
    root.style.scrollBehavior = previousRootBehavior;
    if (document.body) document.body.style.scrollBehavior = previousBodyBehavior;
  }

  function performRestore(state) {
    if (!state || restoreRunning) return;

    restoreRunning = true;
    window.__yfSiteReturnRestorePending = true;
    hideForRestore();
    restoreDetails(state);

    var attempts = 0;
    var stableFrames = 0;
    var previous = null;
    var started = now();

    function settle() {
      attempts += 1;
      var position = targetScroll(state);
      instantScroll(position);
      restoreInnerScroll(state);

      requestAnimationFrame(function () {
        var next = targetScroll(state);
        var sameTarget = previous && Math.abs(next.y - previous.y) <= 1 && Math.abs(next.x - previous.x) <= 1;
        var sameScroll = Math.abs((window.pageYOffset || 0) - next.y) <= 1 && Math.abs((window.pageXOffset || 0) - next.x) <= 1;
        stableFrames = sameTarget && sameScroll ? stableFrames + 1 : 0;
        previous = next;

        var timedOut = now() - started > 1800;
        if (stableFrames >= 3 || attempts >= 36 || timedOut) {
          instantScroll(next);
          restoreInnerScroll(state);
          requestAnimationFrame(revealAfterRestore);
          return;
        }

        settle();
      });
    }

    requestAnimationFrame(settle);
  }

  function waitForDynamicContentThenRestore(state) {
    var waited = 0;

    function tryRestore() {
      if (matchingCollectionReturnExists() || window.__yfCollectionReturnRestorePending) {
        // Collection/search infinite-scroll restoration owns visibility and will
        // reveal the page after rebuilding the exact loaded-page count.
        document.documentElement.classList.remove(RESTORING_CLASS);
        return;
      }

      if (window.__yfCollectionHistoryPopPending && waited < 5000) {
        waited += 40;
        window.setTimeout(tryRestore, 40);
        return;
      }

      performRestore(state);
    }

    tryRestore();
  }

  function beginRestore() {
    if (restoreRunning) return;

    var state = readState() || window.__yfPrepaintSiteReturnState || null;
    if (!state || state.key !== routeKey() || !isFresh(state)) {
      document.documentElement.classList.remove(RESTORING_CLASS);
      window.__yfSiteReturnRestorePending = false;
      return;
    }

    waitForDynamicContentThenRestore(state);
  }

  history.pushState = function (state, title, url) {
    commitState(true);

    var targetKey = routeKey(url || window.location.href);
    var supplied = state && typeof state === 'object' ? state : {};
    var nextReturn = {
      entryId: randomId(),
      key: targetKey,
      scrollX: window.pageXOffset || 0,
      scrollY: window.pageYOffset || 0,
      viewportWidth: window.innerWidth || 0,
      viewportHeight: window.innerHeight || 0,
      documentHeight: document.documentElement.scrollHeight || 0,
      anchor: captureAnchor(),
      innerScroll: [],
      details: [],
      collection: collectionSnapshot(),
      timestamp: now()
    };
    var merged = Object.assign({}, supplied);
    merged[STATE_NAME] = nextReturn;
    var result = originalPushState(merged, title, url);
    storeFallback(nextReturn);
    return result;
  };

  history.replaceState = function (state, title, url) {
    var supplied = state && typeof state === 'object' ? state : {};
    var current = currentHistoryObject();
    var targetKey = routeKey(url || window.location.href);
    var existing = supplied[STATE_NAME] || current[STATE_NAME] || readFallback(routeKey());
    // Respect the caller's replacement semantics. Preserve only this
    // restoration payload when the caller did not explicitly include it;
    // do not resurrect app keys (such as a cleared collection return state).
    var merged = Object.assign({}, supplied);

    if (existing) {
      merged[STATE_NAME] = Object.assign({}, existing, {
        key: targetKey,
        timestamp: now()
      });
    }

    return originalReplaceState(merged, title, url);
  };

  function scheduleSave() {
    if (restoreRunning) return;
    window.clearTimeout(saveTimer);
    saveTimer = window.setTimeout(function () { commitState(false); }, SCROLL_SAVE_DELAY);
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!target) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (target.target === '_blank' || target.hasAttribute('download')) return;

    var destination;
    try { destination = new URL(target.href, window.location.href); } catch (error) { return; }
    if (destination.origin !== window.location.origin) return;
    if (destination.href === window.location.href) return;

    navigationPending = true;
    commitState(true);
  }, true);

  document.addEventListener('submit', function () {
    navigationPending = true;
    commitState(true);
  }, true);

  window.addEventListener('scroll', scheduleSave, { passive: true });
  window.addEventListener('resize', scheduleSave, { passive: true });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') commitState(true);
  });

  window.addEventListener('pagehide', function (event) {
    commitState(true);

    if (event.persisted && !window.__yfCollectionProductNavigationPending && !matchingCollectionReturnExists()) {
      hideForRestore();
    }
  });

  window.addEventListener('pageshow', function (event) {
    navigationPending = false;
    if (event.persisted || document.documentElement.classList.contains(RESTORING_CLASS)) {
      beginRestore();
    } else {
      document.documentElement.classList.remove(RESTORING_CLASS);
    }
  });

  window.addEventListener('popstate', function (event) {
    var state = event.state && event.state[STATE_NAME];
    if (!state) state = readFallback(routeKey());
    if (!state || state.key !== routeKey() || !isFresh(state)) return;

    hideForRestore();
    window.__yfPrepaintSiteReturnState = state;
    window.setTimeout(function () { waitForDynamicContentThenRestore(state); }, 0);
  });

  window.addEventListener('yf:dynamic-content-ready', function () {
    if (!document.documentElement.classList.contains(RESTORING_CLASS)) return;
    beginRestore();
  });

  window.addEventListener('yf:collection-return-restored', function () {
    var state = readState();
    if (!state) return;
    restoreDetails(state);
    restoreInnerScroll(state);
  });

  window.YFSiteReturnState = {
    save: function () { return commitState(true); },
    restoreAuxiliary: function () {
      var state = readState();
      if (!state) return;
      restoreDetails(state);
      restoreInnerScroll(state);
    }
  };

  if (!currentHistoryObject()[STATE_NAME]) commitState(true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.documentElement.classList.contains(RESTORING_CLASS)) beginRestore();
    }, { once: true });
  } else if (document.documentElement.classList.contains(RESTORING_CLASS)) {
    beginRestore();
  }

  window.setTimeout(function () {
    if (document.documentElement.classList.contains(RESTORING_CLASS) && !restoreRunning && !window.__yfCollectionReturnRestorePending) {
      beginRestore();
    }
  }, 1200);

  window.setTimeout(function () {
    document.documentElement.classList.remove(RESTORING_CLASS);
  }, 12000);
})();
